<template>
  <Container class="page-event">
    
    <div class="tac pt-5 pb-4">
      <h1 class="">
        Liquidity Event
      </h1>
    </div>

    <!-- 大字时间 -->
    <div class="timer-line pt-4" style="color: #EB9656;">
      <BaseUniTimeCountDown 
        :cfg_stamp="cfg_stamp" 
        cfg_max_unit="d" 
        :cfg_with_text_unit="true"
        :cfg_hide_dots="true"
      />
    </div>


    <div v-if="10" class="pt-5">
      <daysChart class="mx-auto"/>
    </div>

    <div v-if="0" class="row">
      <div class="col-md-7">
        <div class="pt-5 tac">
          <h4>
            <span style="font-size: 1.4em;">
              {{num_liquidity_total}} ETH 
            </span>
            Total Contributed
          </h4>
          <h4 v-if="10">{{num_liquidity_my}} ETH Contributed By Me</h4>
        </div>
      </div>
      <div class="col-md-5">
        <div class="pt-3">
          <daysChart class="mx-auto"/>
        </div>
      </div>
    </div>

    <div v-if="10" class="pt-5 tac">
      <h4>
        <span style="font-size: 1.4em;">
          {{num_liquidity_total}} ETH 
        </span>
        Total Contributed
      </h4>
      <h4 v-if="10">{{num_liquidity_my}} ETH Contributed By Me</h4>
    </div>

    <!-- 操作区 -->
    <div class="pt-5" style="max-width: 700px;margin: 0 auto;">

      <div class="row">
        <div class="col-md-6 mb-4">

          <div class="ui-card p-4">

            <!--  -->
            <div class="min-height-box">

              <div class="input-group mb-3">
                <input type="text" v-model.number="input_num_add" class="form-control form-control-lg border-right-none" placeholder="0.0">
                <div class="input-group-append">
                  <span class="input-group-text cp bg-white border-left-none">
                    <span @click="setInputNumAddMax()" class="btn btn-outline-primary btn-sm">
                      Max
                    </span>
                  </span>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text">ETH</span>
                </div>
              </div>
            </div>

            <button @click="status_show_terms_for_add = true" class="ui-btn size-lg w-100">
              Add Liquidity 
            </button>
          </div>

        </div>

        <div class="col-md-6 mb-4">

          <div class="ui-card p-4">

            <!--  -->
            <div class="min-height-box">
              <div class="tac pt-4" style="font-size: 26px;">
                <BaseUniTimeCountDown :cfg_stamp="cfg_stamp" cfg_max_unit="d"/>
              </div>
            </div>

            <button :disabled_xx="statusBtnGetDisable" @click="btnGetClicked()" class="ui-btn size-lg w-100">
              Get LP Tokens
            </button>
            
          </div>
        </div>
      </div>
    </div>

    <!-- Add 弹框 -->
    <UiModal :open="status_show_terms_for_add" @close="status_show_terms_for_add = false">
     <h3 class="m-4 mb-0 text-center">Add Liquidity</h3>
     <div class="px-4 t-dark">
        I'm not a resident of the United States.
        <br>
        I understand that this contract is provided with no warranty of any kind.
        <br>
        I agree to not hold the contract creators, DPO team members or anyone associated with this event liable for any damage monetary and otherwise I might onccur.
        <br>
        I understand that any smart contract interaction carries an inherent risk.
        <br>
     </div>
     <div class="px-4 pb-2 tac">
       <label class="cd usn">
          <input type="checkbox" v-model="status_terms_agreed">
          Agree
        </label>
     </div>
     <div class="px-4 pb-4">
       <button :disabled="!status_terms_agreed" @click="btnAddClicked()" class="btn btn-primary w-100">
         Add Liquidity
       </button>
     </div>
    </UiModal>
  </Container>
</template>

<script>
import { mapActions } from 'vuex';

import daysChart from './days_chart.vue'

export default {
  name: 'liquidityEvent',
  components: {
    daysChart,
  },
  props: [],
  data() {
    
    let cfg_stamp = (new Date('2020/10/20 23:59:59')).valueOf()

    return {
      cfg_stamp: cfg_stamp,
      userETHBalance: 0,
      input_num_add: this.$store.state.web3.account_balance_eth,

      num_liquidity_total: '-',
      num_liquidity_my: '-',

      status_show_terms_for_add: false,
      status_terms_agreed: false,

      statusBtnGetDisable: ((new Date()).valueOf() - cfg_stamp)<=0,
    }
  },
  computed: {
  },
  watch: {
    '$store.state.web3.account_balance_eth'(val,old_val){
      if(!old_val){
        this.input_num_add = val
      }
    },
    '$store.state.web3.account'(){
      this.getLiquidityMy()
      this.getLiquidityTotal()
    },
  },
  methods: {
    ...mapActions([
      'addLiquidity',
      'getAddressETHBalance',
      'claimLPTokensLiquidity',
      'liquidityTotalETHContributed',
      'liquidityETHContributed',
    ]),

    setInputNumAddMax(){
      this.input_num_add = this.$store.state.web3.account_balance_eth
    },

    async btnAddClicked(){
      let v = this
      v.addLiquidity(''+v.input_num_add);
    },
    btnGetClicked(){
      let v = this

      v.claimLPTokensLiquidity()
    },

    run(){
      let v = this;
      // v.userETHBalance = v.getAddressETHBalance('0x77C8DB3A650362107dE9322850c9F8b2aB6F545A');
      // console.log('-------');
      // console.log(v.userETHBalance);
      // console.log('@@@@@@@@');
    },

    // liquidity：全部 
    async getLiquidityTotal(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}
      v.num_liquidity_total = await v.liquidityTotalETHContributed()
    },
    // liquidity：我的 
    async getLiquidityMy(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}
      v.num_liquidity_my = await v.liquidityETHContributed(address)
    },
  },
  created() {
    this.run()
    this.getLiquidityTotal()
    this.getLiquidityMy()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .page-event{
    .timer-line{
      text-align: center;
      /deep/ .jj-count-down{
        // font-family: jmono;
        b{
          // font-weight: bold;
          font-size: 76px;
          display: inline-block;
          padding: 0 10px;
        }
        i{
          font-size: 14px;
        }
      }
    }

    @media(max-width: 789px){
      .timer-line{
        /deep/ .jj-count-down{
          b{
            font-size: 36px;
            padding: 0 5px;
          }
          i{
            font-size: 12px;
          }
        }
      }
    }

    .min-height-box{
      min-height: 100px;
    }
  }
</style>